import { InjectionToken } from '@angular/core';

export interface ToastData {
	count: number;
	showNewToaster: boolean;
}

export const TOAST_DATA = new InjectionToken('TOAST_DATA');
